import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Logs an item edit operation to Firestore
 * @param {string} userId - The ID of the user performing the action
 * @param {string} itemId - The ID of the item being edited
 * @param {Object} oldData - The item data before the edit
 * @param {Object} newData - The item data after the edit
 * @returns {Promise<string>} - The ID of the created log entry
 */
export const logEditOperation = async (userId, itemId, oldData, newData) => {
  try {
    const logEntry = {
      type: 'EDIT',
      userId,
      itemId,
      oldData,
      newData,
      timestamp: Timestamp.now(),
    };
    
    const docRef = await addDoc(collection(db, 'activityLogs'), logEntry);
    console.log('Edit operation logged with ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('Error logging edit operation:', error);
    // Don't throw the error to prevent disrupting the main operation
    return null;
  }
};

/**
 * Logs an item delete operation to Firestore
 * @param {string} userId - The ID of the user performing the action
 * @param {string} itemId - The ID of the item being deleted
 * @param {Object} deletedData - The data of the deleted item
 * @returns {Promise<string>} - The ID of the created log entry
 */
export const logDeleteOperation = async (userId, itemId, deletedData) => {
  try {
    const logEntry = {
      type: 'DELETE',
      userId,
      itemId,
      deletedData,
      timestamp: Timestamp.now(),
    };
    
    const docRef = await addDoc(collection(db, 'activityLogs'), logEntry);
    console.log('Delete operation logged with ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('Error logging delete operation:', error);
    // Don't throw the error to prevent disrupting the main operation
    return null;
  }
};